module.exports = __webpack_public_path__ + "static/media/BIA 200.5722fa94.png";